/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Replace Account Request Body Schema
 * @export
 * @interface ReplaceAccountRequest
 */
export interface ReplaceAccountRequest {
    /**
     * Account Username
     * @type {string}
     * @memberof ReplaceAccountRequest
     */
    username: string;
    /**
     * Account Email
     * @type {string}
     * @memberof ReplaceAccountRequest
     */
    email: string;
    /**
     * Account Given Name
     * @type {string}
     * @memberof ReplaceAccountRequest
     */
    givenName: string;
    /**
     * Account Family Name
     * @type {string}
     * @memberof ReplaceAccountRequest
     */
    familyName: string;
    /**
     * Account Phone Number
     * @type {string}
     * @memberof ReplaceAccountRequest
     */
    phoneNumber: string;
    /**
     * Hide Email From Members
     * @type {boolean}
     * @memberof ReplaceAccountRequest
     */
    hideEmailFromMembers: boolean;
    /**
     * Hide Phone Number From Members
     * @type {boolean}
     * @memberof ReplaceAccountRequest
     */
    hidePhoneFromMembers: boolean;
}

/**
 * Check if a given object implements the ReplaceAccountRequest interface.
 */
export function instanceOfReplaceAccountRequest(value: object): value is ReplaceAccountRequest {
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('givenName' in value) || value['givenName'] === undefined) return false;
    if (!('familyName' in value) || value['familyName'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('hideEmailFromMembers' in value) || value['hideEmailFromMembers'] === undefined) return false;
    if (!('hidePhoneFromMembers' in value) || value['hidePhoneFromMembers'] === undefined) return false;
    return true;
}

export function ReplaceAccountRequestFromJSON(json: any): ReplaceAccountRequest {
    return ReplaceAccountRequestFromJSONTyped(json, false);
}

export function ReplaceAccountRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplaceAccountRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'],
        'email': json['email'],
        'givenName': json['given_name'],
        'familyName': json['family_name'],
        'phoneNumber': json['phone_number'],
        'hideEmailFromMembers': json['hide_email_from_members'],
        'hidePhoneFromMembers': json['hide_phone_from_members'],
    };
}

export function ReplaceAccountRequestToJSON(value?: ReplaceAccountRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'username': value['username'],
        'email': value['email'],
        'given_name': value['givenName'],
        'family_name': value['familyName'],
        'phone_number': value['phoneNumber'],
        'hide_email_from_members': value['hideEmailFromMembers'],
        'hide_phone_from_members': value['hidePhoneFromMembers'],
    };
}

